import { updateDebugSettings } from '@core/hooks/useGeneralSettings';
import { enabled as posthogEnabled } from '@core/services/posthog';
import { logger } from '@waitroom/logger';
import { PostHogFeatureFlag } from '@waitroom/models';
import posthog from 'posthog-js';
import { ReactElement, useEffect } from 'react';
import useStorageSync from '../../../../hooks/useStorageSync';
import { usePostHogFeatureFlag } from '../../../FeatureFlagGate/FeatureFlag';

export const toggleLogs = (enabled: boolean) => {
  const logLevel = enabled ? 5 : 0;
  logger.config.logLevel = logLevel;
  if (posthogEnabled) {
    posthog.set_config({
      enable_recording_console_log: enabled,
    });
  }
  updateDebugSettings({
    logEnabled: enabled,
    logLevel,
  });
};

const AppSetup = (): ReactElement | null => {
  useStorageSync();
  const devEnabled = usePostHogFeatureFlag(PostHogFeatureFlag.Dev);

  useEffect(() => {
    // disable logs when flag disabled
    if (devEnabled === false) toggleLogs(false);
  }, [devEnabled]);

  return null;
};
export default AppSetup;
